import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { MAIN_CONTENT_DATA_WRAPPER_SETTINGS } from '../../globals';
import BtnBack from '../../common/BtnBack/BtnBack';
import DataWrapper from '../../common/DataWrapper/DataWrapper';
import ConfirmInfo from './ConfirmInfo';


import { StyledReservationContent } from './styles/StyledReservationContent';


class ReservationContent extends Component {
  render() {
    const {
      officeId, serviceId,
      previousSteps,
      reservationCommon,
      btnBackTitle,
      reserveData,
      confirmData,
      inputs,
      error,
      clickBtnConfirm,
      handleChangeInput,
      handleTimerExpiration,
      officeData,
    } = this.props;

    return (
      <StyledReservationContent>

        <BtnBack
          text={`ZPĚT NA ${btnBackTitle}`}
          linkTo={'/office/' + officeId + '/service/' + serviceId}
        />

          <DataWrapper
            isLoading={reserveData.isLoading}
            status={reserveData.status}
            minHeight={180}
            isLoadingText="Předrezervovávám"
            errorMessage={reserveData.errorType === 'full' ? "Interval je již obsazen" : "Něco se nepovedlo. Zkuste prosím stránku načíst znovu, nebo opakujte akci později."}
            spinnerFat={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.spinnerFat}
            spinnerSize={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.spinnerSize}
            textSizeLoading={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.textSizeLoading}
            textSizeError={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.textSizeError}
          >
            <ConfirmInfo
              officeData={officeData}
              reservationCommon={reservationCommon}
              previousSteps={previousSteps}
              inputs={inputs}
              error={error}
              handleChangeInput={handleChangeInput}
              handleOnClickConfirm={clickBtnConfirm}
              confirmData={confirmData}
              reserveData={reserveData}
              handleTimerExpiration={handleTimerExpiration}
            />
          </DataWrapper>

      </StyledReservationContent>
    );
  }
}

ReservationContent.propTypes = {
  previousSteps: PropTypes.object.isRequired,
  reservationCommon: PropTypes.object.isRequired,
  serviceId: PropTypes.string.isRequired,
  officeId: PropTypes.string.isRequired,
  confirmReservation: PropTypes.func.isRequired,
  confirmData: PropTypes.object.isRequired,
  reserveData: PropTypes.object.isRequired,
  inputs: PropTypes.object.isRequired,
  clickBtnConfirm: PropTypes.func.isRequired,
  handleChangeInput: PropTypes.func.isRequired,
  handleTimerExpiration: PropTypes.func.isRequired,
  timezone: PropTypes.string.isRequired,
  officeData: PropTypes.object.isRequired,
};


export default ReservationContent;
